import { Spin, Modal, Button, Form, Input, InputNumber, Row, Col } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { createRef } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { PlusCircle } from "react-feather";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { CardBody } from "reactstrap";
import { H5, Btn } from "../../../../AbstractElements";
import {
  OrganisationFlowMembers,
  OrganisationFlows,
  OrganisationUsers,
} from "../../../../api";
import { LogEvents, LoggerContext } from "../../../../context/logging";
import { organisationEditGranted } from "../../../../utils/PermissionFunctions/userPermissions";
import { useAPIUser } from "../../../../_helper/User/UserProvider";
const mapStateToProps = ({ dispatch, settings }) => ({
  dispatch,
  settings,
});
const ApprovalFlow = (props) => {
  const logger = React.useContext(LoggerContext);

  const formRef = createRef();
  const [loading, setLoading] = useState(false);
  const { userDetails, setUserDetails } = useAPIUser();
  const [memberList, setMemberList] = useState([]);
  const [steps, setSteps] = useState([]);
  const [organisationFlowMembers, setOrganisationFlowMembers] = useState([]);
  const [columns, setColumns] = useState({});
  const [modal1Visible, setModal1Visible] = useState(false);
  useEffect(() => {
    fetchMemberList();
  }, []);
  const fetchMembers = () => {
    axios.get(`${OrganisationFlowMembers}`).then((res) => {
      setOrganisationFlowMembers(res.data);
    });
  };
  const fetchMemberList = () => {
    var memberList = [];
    var newList = [];
    setLoading(true);
    axios
      .get(`${OrganisationFlowMembers}`, {
        params: {
          organisation_approval_flow__branch: props?.settings?.branch?.id,
        },
      })
      .then((response) => {
        setOrganisationFlowMembers(response.data);
        memberList = response.data.map((each) => each?.organisation_member);
      })
      .then(() => {
        axios
          .get(`${OrganisationUsers}`, {
            params: {
              branch: props?.settings?.branch?.id,
              user__is_active: true,
            },
          })
          .then((res) => {
            var filteredMemberList = res.data?.filter(
              (each) => !memberList.includes(each?.id)
            );
            console.log("filteredMemberList", filteredMemberList);
            for (var i = 0; i < filteredMemberList?.length; i++) {
              var obj = {
                id: String(filteredMemberList[i].id),
                organisation_approval_flow: null,
                organisation_member: filteredMemberList[i].id,
                organisation_member_name: filteredMemberList[i]?.user?.name,
              };
              newList.push(obj);
            }
          })
          .then(() => {
            fetchApprovalFlows(newList);
          });
      });
  };
  const fetchApprovalFlows = (newList) => {
    console.log(newList, "newlist");
    axios
      .get(`${OrganisationFlows}`, {
        params: {
          branch: props?.settings?.branch?.id,
        },
      })
      .then((res) => {
        setSteps(res.data);
        var array = res.data;
        var columnsNew = {
          ["col1col"]: {
            name: "Members",
            items: newList,
          },
        };
        const result = {};
        for (var i = 0; i < array.length; i++) {
          var itemList = array[i]?.organisation_approval_flow_members;
          const id = "flow " + array[i].id;
          const key = id;
          columnsNew[id] = {
            name: array[i]?.approval_flow_name,
            items: itemList,
            limit: array[i]?.approval_limit,
          };
        }
        setColumns(columnsNew);
        setLoading(false);
      });
  };
  // useEffect(() => {}, [columns]);
  const onDragEnd = (result, columns, setColumns) => {
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
      if (
        source.droppableId === "col1col" &&
        destination.droppableId !== "col1col"
      ) {
        // ADD INTO A FLOW
        var flowId = Number(destination.droppableId.split(" ")[1]);
        var userOrganisationId = Number(result.draggableId);
        const formValues = new FormData();
        formValues.append("organisation_approval_flow", flowId);
        formValues.append("organisation_member", userOrganisationId);
        axios.post(`${OrganisationFlowMembers}`, formValues).then((res) => {
          toast.success("Member Successfully Added to Flow");
          fetchMembers();
        });
      } else if (
        destination.droppableId === "col1col" &&
        source.droppableId !== "col1col"
      ) {
        var flowId = Number(source.droppableId.split(" ")[1]);
        var userOrganisationId = Number(result.draggableId);
        var editId = organisationFlowMembers.filter(
          (each) => each.organisation_member === userOrganisationId
        )[0]?.id;
        axios.delete(`${OrganisationFlowMembers}${editId}/`).then((res) => {
          toast.success("Member Successfully Removed from Flow");
          fetchMembers();
        });
      } else {
        var flowIdAdd = Number(destination.droppableId.split(" ")[1]);
        var flowIdRemove = Number(source.droppableId.split(" ")[1]);
        var userOrganisationId = Number(result.draggableId);
        var editId = organisationFlowMembers.filter(
          (each) => each.organisation_member === userOrganisationId
        )[0]?.id;
        axios
          .delete(`${OrganisationFlowMembers}${editId}/`)
          .then((res) => {
            toast.success("Member Successfully Removed from Flow");
          })
          .then(() => {
            const formValues = new FormData();
            formValues.append("organisation_approval_flow", flowIdAdd);
            formValues.append("organisation_member", userOrganisationId);
            axios.post(`${OrganisationFlowMembers}`, formValues).then((res) => {
              toast.success("Member Successfully Added to Flow");
              fetchMembers();
            });
          });
      }
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
    }
  };
  const addStep = () => {
    logger.log(LogEvents.submitApprovalFlow, {});
    const formValues = formRef.current.getFieldsValue();
    const formData = new FormData();
    formData.append("approval_flow_name", formValues.approval_flow_name);
    formData.append("approval_limit", formValues.approval_limit);
    formData.append("status", true);
    formData.append(
      "organisation",
      props?.settings?.user?.organisation?.organisation_id
    );
    formData.append("branch", props?.settings?.branch?.id);
    formData.append("position", steps.length + 1);
    axios
      .post(`${OrganisationFlows}`, formData)
      .then((res) => {
        toast.success("Step Added Successfully!");
        formRef.current.resetFields();
        setModal1Visible(false);
        fetchMemberList();
      })
      .catch((res) => {
        toast.error("Something went wrong!");
      });
  };
  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center">
          <Spin size="large" />
        </div>
      ) : (
        <CardBody>
          <div className="d-flex">
            {organisationEditGranted(props.settings?.user) && (
              <Button
                className="btn btn-primary d-flex align-items-center"
                style={{ color: "white", margin: 8 }}
                onClick={() => {
                  setModal1Visible(true);
                  logger.log(LogEvents.addApprovalFlowStep, {});
                }}
              >
                {" "}
                <PlusCircle />
                <div style={{ marginLeft: "4px" }}>Add Step</div>
              </Button>
            )}
          </div>
          <div style={{ display: "flex", overflowX: "scroll" }}>
            <DragDropContext
              onDragEnd={(result) => {
                if (organisationEditGranted(props.settings?.user)) {
                  onDragEnd(result, columns, setColumns);
                } else {
                  toast.info("You do not have the access to perform this action.");
                }
              }}
            >
              {Object.entries(columns).map(([columnId, column], index) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                    key={columnId}
                  >
                    <div style={{ margin: 8 }}>
                      <Droppable droppableId={columnId} key={columnId}>
                        {(provided, snapshot) => {
                          return (
                            <div
                              className="rounded"
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              style={{
                                padding: 12,
                                minWidth: "300px",
                                minHeight: "400px",
                                boxShadow:
                                  "rgba(0, 0, 0, 0.12) 0px 1px 3px, rgba(0, 0, 0, 0.24) 0px 1px 2px",
                              }}
                            >
                              <div className="text-center py-2">
                                <H5>{column.name}</H5>
                                <H5>
                                  {column?.limit
                                    ? `Threshold > ₹${column?.limit}`
                                    : null}
                                </H5>
                              </div>
                              {column.items.map((item, index) => {
                                return (
                                  <Draggable
                                    key={item.id}
                                    draggableId={String(
                                      item?.organisation_member
                                    )}
                                    index={index}
                                  >
                                    {(provided, snapshot) => {
                                      return (
                                        <div
                                          className="shadow-sm rounded"
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={{
                                            userSelect: "none",
                                            padding: 16,
                                            margin: "0 0 8px 0",
                                            minHeight: "50px",
                                            backgroundColor: snapshot.isDragging
                                              ? "#5B8FF9"
                                              : "#ADC7FC",
                                            color: "white",
                                            ...provided.draggableProps.style,
                                          }}
                                        >
                                          {item?.organisation_member_name}
                                        </div>
                                      );
                                    }}
                                  </Draggable>
                                );
                              })}
                              {provided.placeholder}
                            </div>
                          );
                        }}
                      </Droppable>
                    </div>
                  </div>
                );
              })}
            </DragDropContext>
          </div>
        </CardBody>
      )}
      <Modal
        title="Add Step"
        centered
        visible={modal1Visible}
        onCancel={() => {
          formRef.current.resetFields();
          setModal1Visible(false);
        }}
        footer={[
          <Button
            key="submit"
            className="btn btn-primary text-white"
            htmlType="submit"
            loading={loading}
            form="stepForm"
          >
            Submit
          </Button>,
          <Button
            key="back"
            onClick={() => {
              formRef.current.resetFields();
              setModal1Visible(false);
            }}
          >
            Cancel
          </Button>,
        ]}
      >
        <Form
          layout="vertical"
          id="stepForm"
          className="px-2"
          ref={formRef}
          // onFinish={addProject}
          onFinish={() => {
            addStep();
          }}
        >
          <Row gutter={24}>
            <Col sm={12}>
              <Form.Item
                name={"approval_limit"}
                label="Approval Limit"
                // rules={[
                //   {
                //     required: true,
                //     pattern:/^\d{10}$/,
                //     message: "Approval Limit is required",
                //   },
                // ]}
              >
                <InputNumber
                  className="w-100"
                  placeholder="Rs 10000"
                  type="number"
                />
              </Form.Item>
            </Col>
            <Col sm={12}>
              <Form.Item
                name={"approval_flow_name"}
                label="Flow Name"
                rules={[
                  {
                    required: true,
                    pattern: /^[^*|\":<>[\]{}`\\()';@&$]+$/,
                    message: "Enter valid flow name",
                  },
                ]}
              >
                <Input className="w-100" placeholder="Flow Name" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default connect(mapStateToProps)(ApprovalFlow);
